
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  RepatriationOpportunityCreationRequest,
  RepatriationOpportunityGroupResource,
} from '../models';
import {
    RepatriationOpportunityCreationRequestFromJSON,
    RepatriationOpportunityCreationRequestToJSON,
    RepatriationOpportunityGroupResourceFromJSON,
    RepatriationOpportunityGroupResourceToJSON,
} from '../models';

export interface CreateRepatriationOpportunityGroupRequest {
    repatriationOpportunityCreationRequest: RepatriationOpportunityCreationRequest;
}

/**
 * 
 */
export class RepatriationOpportunityGroupsApi extends runtime.BaseAPI {

    /**
     * Create repatriation opportunity group
          */
    async createRepatriationOpportunityGroupRaw(requestParameters: CreateRepatriationOpportunityGroupRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<RepatriationOpportunityGroupResource>> {
        if (requestParameters['repatriationOpportunityCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'repatriationOpportunityCreationRequest',
                'Required parameter "repatriationOpportunityCreationRequest" was null or undefined when calling createRepatriationOpportunityGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<RepatriationOpportunityGroupResource>({
            path: `/repatriation-opportunity/api/repatriation-opportunity-groups`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RepatriationOpportunityCreationRequestToJSON(requestParameters['repatriationOpportunityCreationRequest']),
        }, initOverrides);

        if (response._data) { response._data=RepatriationOpportunityGroupResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Create repatriation opportunity group
          */
    async createRepatriationOpportunityGroup(requestParameters: CreateRepatriationOpportunityGroupRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<RepatriationOpportunityGroupResource> {
        const response = await this.createRepatriationOpportunityGroupRaw(requestParameters, initOverrides);
        return response._data;
    }

}
